<template>
    <div>
        <div class="omheader">
            <div class="omheader-info">
                <div class="omheader-left" @click="onBack">
                    <van-icon name="arrow-left" :size="20" />
                </div>
                <div class="omheader-search">
                    <div class="search">
                        <van-search v-model="searchvalue" @search="onsearch" shape="round"   :placeholder="placeholder" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { NavBar  } from 'vant';
export default {
    name:'navsearch',
    props:{
        placeholder:{type:String,default:'搜索我的订单'}
    },
    data(){
        return {
            searchvalue:''
        }
    },
    methods: {
        onBack() {
        //history.back();
        this.$router.back(-1)
        },
        onsearch(value)
        {
            this.$emit('onsearch',value);
        }
    }
}
</script>

<style lang="scss" scoped>
.omheader{
    height: 36px;
    padding: 5px;
    background-color: white;
}
.omheader-info{
    position: relative;
}
.omheader-left{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    text-align: center;
}
.omheader-search{
    height: 36px;
    padding-left: 35px;
    padding-right: 75px;
}
.van-search{
    padding: 0;
    border: 1px solid #ff9369;
    border-radius: 999px;
}
.omheader-search .van-search .van-cell{
    padding: 3px 8px 3px 0;
}
</style>
